<template>
    <div class="tab-wrapper">
        <div class="tab">
            <button
                v-for="(tab, tabIndex) in tabs"
                :key="tabIndex"
                :ref="tab.name"
                :class="tabClass(tab.name, tabIndex)"
                @click="tabClicked(tab.name)"
                @mouseover="tabMouseOver(tab.name)"
                @mouseleave="tabMouseLeave(tab.name)"
            >
                <span class="tab__name">
                    <template v-if="tab.icon">
                        <common-icon :name="tab.icon" size="huge"></common-icon>
                    </template>
                    {{ tab.displayName || tab.name }}
                </span>
                <div v-if="tab.badge" class="badge-holder">
                    <common-badge :content="tab.badge"></common-badge>
                </div>
            </button>
        </div>
        <div class="tabcontent">
            <slot :name="selectedTab"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            tabs: { type: Array, required: true, validator: (arr) => !!arr && arr.length },
            activeTab: { type: String, required: true },
        },
        data() {
            return {
                selectedTab: this.activeTab,
            }
        },
        methods: {
            tabClicked(tabName) {
                this.selectedTab = tabName
                this.emitEvent({ name: 'tab-click', payload: tabName })
            },
            tabMouseOver(tabName) {
                if (this.selectedTab !== tabName) {
                    this.$refs[this.selectedTab][0].classList.add('tablink-mouseover')
                    this.$refs[tabName][0].classList.add('tablinks__hover')
                }
            },
            tabMouseLeave(tabName) {
                if (this.selectedTab !== tabName) {
                    this.$refs[this.selectedTab][0].classList.remove('tablink-mouseover')
                    this.$refs[tabName][0].classList.remove('tablinks__hover')
                }
            },
            tabClass(tabName, tabIndex) {
                return {
                    tablinks: true,
                    activetablink: this.selectedTab === tabName,
                    activetablink__first: tabIndex === 0,
                }
            },
        },
        watch: {
            selectedTab(newValue, oldValue) {
                this.$refs[newValue][0].classList.add('activetablink')
                this.$refs[newValue][0].classList.remove('tablinks__hover')

                this.$refs[oldValue][0].classList.remove('activetablink')
                this.$refs[oldValue][0].classList.remove('tablink-mouseover')

                this.$emit('selectedTab', newValue)
            },

            activeTab() {
                this.selectedTab = this.activeTab
            },
        },
    }
</script>
